import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { getText } from './constants';

export const BoardsDialog = ({
  isOpen,
  onOpenChange,
  language,
  boards,
  currentBoardIndex,
  newBoardName,
  setNewBoardName,
  onSelectBoard,
  onAddBoard,
  onDeleteBoard
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby="boards-dialog-description">
        <DialogHeader>
          <DialogTitle>{getText('boards', language)}</DialogTitle>
          <DialogDescription id="boards-dialog-description">
            {language === 'de'
              ? 'Verwalte deine Pinwände. Du kannst bis zu 10 Pinwände erstellen.'
              : 'Manage your pinboards. You can create up to 10 pinboards.'}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 pt-4">
          {/* Existing boards */}
          <div className="space-y-2">
            {boards.map((board, idx) => (
              <div 
                key={board.id} 
                className={`flex items-center justify-between p-3 rounded-lg border ${
                  idx === currentBoardIndex ? 'border-[#006039] bg-[#006039]/5' : 'border-slate-200'
                }`}
                data-testid={`board-item-${board.id}`}
              >
                <button
                  onClick={() => {
                    onSelectBoard(idx);
                    onOpenChange(false);
                  }}
                  className="flex-1 text-left font-medium"
                  data-testid={`select-board-${board.id}`}
                >
                  {board.name}
                </button>
                {board.id !== 'default' && (
                  <Button
                    variant="ghost"
                    size="icon"
                    className="h-8 w-8 text-red-500 hover:text-red-600"
                    onClick={() => onDeleteBoard(board.id)}
                    data-testid={`delete-board-${board.id}`}
                  >
                    <Trash2 className="h-4 w-4" />
                  </Button>
                )}
              </div>
            ))}
          </div>
          
          {/* Add new board */}
          {boards.length < 10 && (
            <div className="flex gap-2">
              <Input
                value={newBoardName}
                onChange={(e) => setNewBoardName(e.target.value)}
                placeholder={getText('boardName', language)}
                onKeyDown={(e) => e.key === 'Enter' && onAddBoard()}
                data-testid="new-board-name-input"
              />
              <Button onClick={onAddBoard} className="bg-[#006039] hover:bg-[#004d2e]" data-testid="create-board-btn">
                <Plus className="h-4 w-4" />
              </Button>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BoardsDialog;
